const UserActionTypes = {
  SET_USER_TO_STATE: 'SET_USER_TO_STATE',
  SET_USER: 'SET_USER',
  REMOVE_USER: 'REMVOE_USER'
};

export default UserActionTypes;
